// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-label-text a{font-weight:700;--text-opacity:1;color:#2b5449;color:rgba(43,84,73,var(--text-opacity))}.form-label-text a:hover{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}", ""]);
// Exports
module.exports = exports;
